import React from 'react';
import { cx } from '../shared/ui/utils';

const ListingHeaderBar = ({
  title,
  subtitle,
  chips = [],
  onClearAll,
  showing = 0,
  total = 0,
  viewMode = 'grid',
  onViewChange,
  sort,
  onSortChange,
  sortOptions = [],
  labels = {},
}) => {
  return (
    <div className="sticky top-16 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto max-w-[92rem] px-4 py-4">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-600">Packages</p>
            <h1 className="mt-2 text-2xl font-semibold text-slate-900">{title}</h1>
            {subtitle ? <p className="mt-1 text-sm text-slate-500">{subtitle}</p> : null}
          </div>
          <div className="flex w-full flex-wrap items-center gap-3 text-sm lg:w-auto lg:justify-end">
            <div className="text-xs text-slate-500 sm:text-sm">
              {labels.resultsLabel || 'Showing'} {showing} of {total}
            </div>
            <div className="flex items-center rounded-full border border-slate-200 bg-white px-2 py-1 text-xs">
              <button
                type="button"
                onClick={() => onViewChange?.('grid')}
                className={cx(
                  'rounded-full px-2 py-1',
                  viewMode === 'grid' ? 'bg-slate-900 text-white' : 'text-slate-500'
                )}
                aria-label="Grid view"
              >
                <i className="bi bi-grid-3x3-gap" />
              </button>
              <button
                type="button"
                onClick={() => onViewChange?.('list')}
                className={cx(
                  'rounded-full px-2 py-1',
                  viewMode === 'list' ? 'bg-slate-900 text-white' : 'text-slate-500'
                )}
                aria-label="List view"
              >
                <i className="bi bi-list" />
              </button>
            </div>
            <select
              value={sort}
              onChange={(e) => onSortChange?.(e.target.value)}
              className="w-full rounded-full border border-slate-200 px-3 py-2 text-sm sm:w-auto"
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          {chips.map((chip) => (
            <span
              key={chip.key}
              className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold text-slate-700"
            >
              {chip.label}
              {chip.onRemove ? (
                <button
                  type="button"
                  onClick={chip.onRemove}
                  className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-white text-[10px] text-slate-500"
                  aria-label={`Remove ${chip.label}`}
                >
                  <i className="bi bi-x-lg" aria-hidden="true" />
                </button>
              ) : null}
            </span>
          ))}
          {chips.length ? (
            <button
              type="button"
              onClick={onClearAll}
              className="w-full rounded-full border border-slate-200 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-slate-600 sm:ml-auto sm:w-auto"
            >
              {labels.clearAll || 'Clear all'}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ListingHeaderBar;
